<template>
  <SubmitButtonMagenta
    v-allowed.editor
    v-if="!isArchived"
    spinner-color="#fff"
    :loading="loading"
    :disabled="disabled"
    @click="archiveTemplate"
  >
    Archivar
  </SubmitButtonMagenta>
</template>

<script>
// Utils
import { checkApiResponse } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
import TemplateButtonMixin from '../mixins/templatesButtons'
import TemplatesStatusControl from '../mixins/statusControl'

// Preparing notification
const notification = new Notification()
notification.timeout = 4000

export default {
  name: 'TemplatesArchiveButton',

  mixins: [TemplateButtonMixin, TemplatesStatusControl],

  methods: {
    async archiveTemplate() {
      this.toggleLoadingStatus()

      const post = await this.$store.dispatch('templates/updateTemplate', {
        status: 'archived',
      })

      if (!checkApiResponse(post)) return this.toggleLoadingStatus()
      this.$router.push({ name: 'templates-listing' })
      this.toggleLoadingStatus()
      // sending notification
      notification.type = 'success'
      notification.message = `Plantilla archivada con éxito`
      notification.dispatch()
    },
  },

  computed: {
    template() {
      return this.$store.state.templates.templatePublished
    },

    isArchived() {
      return this.template.status === 'archived'
    },
  },
}
</script>

<style scoped></style>
